/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getVideoList.defs.js";
export { main as default } from "./getVideoList.defs.js";
